import React, {Component} from 'react'
import {withTranslation} from "react-i18next";

import styled from '@emotion/styled'
import sv from '../styles/marketing'

import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {userService} from "../_services";
import {isMobileOnly} from "react-device-detect";
import {AnimatedLoader, Container, IsVerifying, StyledMedia} from "../styles/CommonStyler";
import AuthBase from "../components/AuthBase";
import zoomIcon from "../images/zoom.svg"
import {connect} from "react-redux";

// STYLE ##########################################################

const Sections = styled('div')`
  ${sv.flexColumn};
`;

const Section = styled('div')`
  margin: 25px;
`;

const SectionContent = styled('div')`
  ${sv.flexCenter};
  ${sv.flexColumn};
  > div {
    margin-top: 20px;
  }
`;

const Heading = styled('h1')`
  color: ${sv.colors.body};
`;

const Button = styled('div')`
  ${sv.buttonBase};
  background: ${sv.colors.body};
  color: ${sv.colors.light};
`;

const LinkButton = styled('a')`
  text-align: center;
  text-decoration: underline;
  color: ${sv.colors.body};
  cursor: pointer;
`;

const ZoomSection = styled('div')`
  ${sv.flexCenter};
  ${sv.flexColumn};
`;

const ZoomIcon = styled('img')`
  width: 100px;
`;

const CancelButton = styled('div')`
  ${sv.buttonBase};
  background: ${sv.colors.light};
  color: ${sv.colors.body};
  border: ${'1px solid ' + sv.colors.body};
`;

// COMPONENT ##########################################################

class AccountSettings extends Component {

  render() {
    const {t, users} = this.props;

    const connectedToZoom = userService.isConnectedToZoom(users);
    const fetchingIntegration = (users && users.info && users.info.loading);

    return (
        <StyledMedia>
          <Container isMobile={isMobileOnly}>

            <Header/>

            <AuthBase title={t("Account Settings")}>
              <Sections>

                <Section>
                  <Heading>{t("Security")}</Heading>
                  <SectionContent>
                    <Button onClick={() => this.props.history.push('/password/change')}>{t("Change Password")}</Button>
                  </SectionContent>
                </Section>

                <Section>
                  <Heading>{t("Administrative")}</Heading>
                  <SectionContent>
                    <Button onClick={() => this.props.history.push('/payment')}>{t("Payment Information")}</Button>
                    <Button onClick={() => window.location.replace('/pricing')}>{t("Change Subscription")}</Button>
                    <CancelButton onClick={() => this.props.history.push('/cancel')}>{t("Cancel Account")}</CancelButton>
                  </SectionContent>
                </Section>

                <Section>
                  <Heading>{t("Integrations")}</Heading>
                  <SectionContent>
                    <ZoomSection>
                      {/* if integration is being refreshed, then show a loader */}
                      { fetchingIntegration &&
                      <IsVerifying><AnimatedLoader color={sv.colors.body}/></IsVerifying>
                      }

                      {/* if integration is not being refreshed, then load zoom state from cookies */}
                      {!fetchingIntegration &&
                      <>
                        {/* if not connected to zoom*/}
                        {!connectedToZoom &&
                        <LinkButton onClick={() => this.props.history.push('/zoom/connect')}>
                          <div>{t("Connect with Zoom to create Gists of your meetings")}</div>
                          <ZoomIcon src={zoomIcon} alt="Zoom"/>
                        </LinkButton>
                        }

                        {/* if connected to zoom*/}
                        {connectedToZoom &&
                        <LinkButton onClick={() => this.props.history.push('/order/zoom/')}>
                          <div>{t("Create Gist")}</div>
                          <ZoomIcon src={zoomIcon} alt="Zoom"/>
                        </LinkButton>
                        }
                      </>
                      }
                    </ZoomSection>
                  </SectionContent>
                </Section>

              </Sections>
            </AuthBase>

            <Footer />

          </Container>
        </StyledMedia>


    )
  }
}

function mapStateToProps(state){
  const {users} = state;
  return {
    users
  }
}

const connectedSettings = withTranslation()(connect(mapStateToProps)(AccountSettings));
export { connectedSettings as AccountSettings };
